import { ConsumerAuctionDTO } from "../types/types";

import { atomWithStorage } from "jotai/utils";

export const auctionAtom = atomWithStorage<Partial<ConsumerAuctionDTO>>(
  "auctionAtom",
  {} as Partial<ConsumerAuctionDTO>,
  undefined,
  { getOnInit: true }
);
